import React from "react";
import "../product-video.css";
import type { ProductVideoEntry } from "./productVideos";

// Shows a product's promo video with a WhatsApp follow-up. Renders nothing when the product has no video.
// preload="none": nothing downloads until the visitor presses play.
export default function ProductVideo({ video }: { video?: ProductVideoEntry }) {
  if (!video) return null;
  return (
    <section className="pv-section" aria-label="Product video">
      <div className="pv-copy">
        <p className="pv-eyebrow">Watch it in action</p>
        <h2>{video.title}</h2>
        <p className="pv-caption">{video.caption}</p>
        <a className="pv-whatsapp" href={video.whatsapp} target="_blank" rel="noopener noreferrer">
          Ask about it on WhatsApp
        </a>
      </div>
      <video
        key={video.src}
        className="pv-player"
        controls
        playsInline
        preload="none"
        poster={video.poster}
        width={720}
        height={900}
        aria-label={video.title}
      >
        <source src={video.src} type="video/mp4" />
      </video>
    </section>
  );
}
